import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isAvailableFeatureSelector } from 'features/billing';
const wrapperCss = "wxelz84";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const EventTypeInfo = ({
  duration,
  durationOptions,
  kindDescription,
  locationType,
  locationTypesCount = 0,
  color = 'muted'
}) => {
  const isMultipleDurationsAvailable = useSelector(state => isAvailableFeatureSelector(state, {
    featureKey: 'multiple_durations'
  }));
  const durationOptionsCount = durationOptions?.length;
  const LOCATION_TYPE_TO_LABEL_MAP = useMemo(() => ({
    physical: I18n.t('publisher.event_types.location.physical.label'),
    custom: I18n.t('publisher.event_types.location.custom.label'),
    inbound_call: I18n.t('publisher.event_types.location.inbound_call.label'),
    outbound_call: I18n.t('publisher.event_types.location.outbound_call.label'),
    zoom_conference: I18n.t('publisher.event_types.location.zoom_conference.label'),
    google_conference: I18n.t('publisher.event_types.location.google_conference.label'),
    gotomeeting_conference: I18n.t('publisher.event_types.location.gotomeeting_conference.label'),
    microsoft_teams_conference: I18n.t('publisher.event_types.location.microsoft_teams_conference.label'),
    webex_conference: I18n.t('publisher.event_types.location.webex_conference.label'),
    ask_invitee: I18n.t('publisher.event_types.location.ask_invitee.label')
  }), []);
  const locationInfo = useMemo(() => {
    if (!locationTypesCount) return null;
    if (locationTypesCount === 1) return LOCATION_TYPE_TO_LABEL_MAP[locationType];
    return I18n.t('publisher.event_types.card.locations_count', {
      count: locationTypesCount
    });
  }, [locationType, locationTypesCount, LOCATION_TYPE_TO_LABEL_MAP]);
  const durationInfo = useMemo(() => {
    const showSingleDuration = !isMultipleDurationsAvailable || !durationOptionsCount || durationOptionsCount < 2;
    if (showSingleDuration) {
      return duration;
    }
    return I18n.t('publisher.event_types.card.durations_count', {
      count: durationOptionsCount
    });
  }, [duration, durationOptionsCount, isMultipleDurationsAvailable]);
  const info = useMemo(() => [durationInfo, locationInfo, kindDescription].filter(Boolean).join(' • '), [durationInfo, locationInfo, kindDescription]);
  return <Wrapper>
      <BodyText color={color} size="medium">
        {info}
      </BodyText>
    </Wrapper>;
};

require("./event_type_info.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_info.js");